module.exports = __webpack_public_path__ + "img/CZ63492555.5a2b7a20.png";